import { setNestedValue } from "./utils";

export type TranslationOverlay = Record<string, Record<string, unknown>>;

const ENGLISH_LOCALES = new Set(["en", "enca", "enus"]);

export const isEnglishLocale = (locale: string | null | undefined): boolean =>
  !!locale && ENGLISH_LOCALES.has(locale.toLowerCase());

export const canRequestTranslation = (locale: string | null | undefined) =>
  !locale || isEnglishLocale(locale);

export const hasForeignLocale = (locale: string | null | undefined) =>
  !!locale && !isEnglishLocale(locale);

/* translation_en is keyed by locale, then by dotted/indexed answer path
   (e.g. incident_evidences[1].incident_evidence_description). Returns
   undefined when there is nothing to overlay. */
export const applyTranslation = <T extends Record<string, any>>(
  submission: T | null | undefined,
  translationEn: unknown,
): T | undefined => {
  const overlay = translationEn as TranslationOverlay | null | undefined;
  const locales = overlay ? Object.keys(overlay) : [];
  if (locales.length === 0) return undefined;

  const translated = JSON.parse(JSON.stringify(submission ?? {}));
  for (const locale of locales) {
    for (const [key, value] of Object.entries(overlay![locale] ?? {})) {
      setNestedValue(translated, key, String(value));
    }
  }
  return translated;
};
